module.exports = __webpack_public_path__ + "static/media/logo-sm.d24031bd.png";